export default __webpack_public_path__ + "static/media/pcbPrinting.9036bd4a.svg";